<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <search-box :company-id="companyId" :token="token" :radius-id="radiusId"/>
                </div>
            </div>
            <search-presenter :company-id="companyId" :token="token">
            </search-presenter>
        </div>
    </div>
</template>

<script>
    import SearchBox from "./SearchBox.vue";
    import SearchPresenter from "./SearchPresenter.vue";
    import {mapGetters} from 'vuex';

    export default {
        name: "PhysicianSearch",
        props: {
            companyId: {type: [Number], required: true}, radiusId: {type: [Number], required: true},
            token: {type: [String], required: true}
        },
        components: {SearchPresenter, SearchBox}
    }
</script>

<style scoped>

</style>